<template>
    <div>
        <Card
            :title="device.nickname || device.name"
            read="Edit"
            @read="load()"
            write="Save"
            @write="save()"
            remove="Remove"
            @remove="remove()"
            :border-variant="device.connected ? 'success' : 'gray'"
        >
            <template v-slot:header-show>
                <b-form-checkbox
                    v-model="mutatedDevice.enabled"
                    switch
                    size="lg"
                    class="d-inline"
                />
            </template>
            <template v-slot:header-hide>
                <b-form-checkbox
                    v-model="device.enabled"
                    switch
                    disabled
                    size="lg"
                    class="d-inline"
                />
            </template>
            <Input text="Name" :value="device.name" disabled />
            <Input text="Nickname" v-model="mutatedDevice.nickname" />
            <hr />
            <Input text="Upload" :value="device.upload | formatData" disabled />
            <Input
                text="Download"
                :value="device.download | formatData"
                disabled
            />
            <Input
                text="Time used"
                :value="device.timeUsed | formatMinute"
                disabled
            />
            <Input
                text="Last connected"
                :value="(device.latestHandshake * 1000) | formatDate"
                :append="(device.latestHandshake * 1000) | formatTimeDistance"
                disabled
            />
            <hr />
            <PeerList :deviceName="device.name" />
        </Card>
    </div>
</template>

<script>
    import Input from '@/components/form/input'
    import Card from '@/components/general/card'

    import PeerList from '@/components/user/peers/list'

    export default {
        props: ['id'],
        data() {
            return {
                mutatedDevice: {}
            }
        },
        methods: {
            load() {
                return this.$store
                    .dispatch('user/devices/loadByID', this.device._id)
                    .then(() => {
                        this.mutatedDevice = { ...this.device }
                    })
            },
            save() {
                return this.$store
                    .dispatch('user/devices/save', this.mutatedDevice)
                    .then(() => {
                        this.$bvToast.toast('Device saved.', {
                            title: 'Success',
                            variant: 'success'
                        })
                    })
            },
            remove() {
                return this.$store
                    .dispatch('user/devices/remove', this.device._id)
                    .then(() => {
                        this.$bvToast.toast('Device removed.', {
                            title: 'Success',
                            variant: 'success'
                        })
                    })
            }
        },
        computed: {
            device() {
                return this.$store.getters['user/devices/getByID'](this.id)
            }
        },
        components: {
            Input,
            Card,
            PeerList
        }
    }
</script>